import { render, staticRenderFns } from "./SizeConfig.vue?vue&type=template&id=7c08bef3&scoped=true&"
import script from "./SizeConfig.vue?vue&type=script&lang=js&"
export * from "./SizeConfig.vue?vue&type=script&lang=js&"
import style0 from "./SizeConfig.vue?vue&type=style&index=0&id=7c08bef3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c08bef3",
  null
  
)

export default component.exports